var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1527.59 416.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre",
    "data-name": "Degradado sin nombre",
    x1: -497.48,
    y1: 827.96,
    x2: -497.48,
    y2: 627.96,
    gradientTransform: "translate(1246.29 1726.14) scale(2.09 -2.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5515f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f041b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-logo"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "417.18 416.28 208.59 416.28 208.59 406.1 407 406.1 407 9.28 10.18 9.28 10.18 207.69 0 207.69 0 -.9 417.18 -.9 417.18 416.28",
    fill: "url(#Degradado_sin_nombre)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "text-logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text-logo-path-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.31,261.04h10.67v-39.63h10.67l19.05,39.63h11.43l-19.51-40.85c8.99-2.29,14.94-8.54,14.94-23.17v-18.29c0-20.42-11.43-24.39-25.91-24.39h-21.34v106.7ZM507.98,212.26v-48.78h10.67c9.3,0,15.24,2.9,15.24,16.77v15.24c0,13.87-5.94,16.77-15.24,16.77h-10.67ZM623.52,154.34v106.7h45.73v-9.15h-35.06v-39.63h25.91v-9.15h-25.91v-39.63h33.53v-9.15h-44.2ZM768.02,154.34h-22.86v106.7h22.86c14.48,0,25.91-4.27,25.91-24.39v-57.92c0-20.42-11.43-24.39-25.91-24.39ZM755.82,163.48h12.19c9.3,0,15.24,2.9,15.24,16.77v54.87c0,13.87-5.94,16.77-15.24,16.77h-12.19v-88.41ZM898.04,262.56c14.33,0,25.91-3.96,25.91-24.39v-3.05c0-24.54-41.15-40.24-41.15-54.87,0-13.87,5.94-16.77,15.24-16.77s15.24,2.9,15.24,16.77v6.1h10.67v-9.15c0-20.42-11.43-24.39-25.91-24.39s-25.91,3.96-25.91,24.39v3.05c0,21.95,41.15,37.65,41.15,54.87,0,13.87-5.94,16.77-15.24,16.77s-15.24-2.9-15.24-16.77v-7.93h-10.67v10.97c0,20.12,11.43,24.39,25.91,24.39ZM1071.19,154.34h-15.24l-18.14,65.24-18.14-65.24h-15.24v106.7h10.67v-84.75l17.22,61.88h10.97l17.22-61.88v84.75h10.67v-106.7ZM1145.57,261.04h10.67l6.1-28.96h27.28l6.1,28.96h10.67l-22.41-106.7h-16l-22.41,106.7ZM1164.32,222.93l11.74-55.94,11.74,55.94h-23.47ZM1280.77,261.04h10.67v-39.63h10.67l19.05,39.63h11.43l-19.51-40.85c8.99-2.29,14.94-8.54,14.94-23.17v-18.29c0-20.42-11.43-24.39-25.91-24.39h-21.34v106.7ZM1291.44,212.26v-48.78h10.67c9.3,0,15.24,2.9,15.24,16.77v15.24c0,13.87-5.94,16.77-15.24,16.77h-10.67ZM1446.61,154.34h-50.3v9.15h19.82v97.55h10.67v-97.55h19.82v-9.15Z",
    fill: "#ff5758"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "tagline-3a78d944-c0db-44d4-8ad5-60158c925687-logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tagline-3a78d944-c0db-44d4-8ad5-60158c925687-logo-path-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.08,276.23h12.78v-47.45h12.78l22.8,47.45h13.7l-23.36-48.91c10.76-2.75,17.89-10.22,17.89-27.74v-21.9c0-24.46-13.7-29.2-31.03-29.2h-25.55v127.76ZM195.85,217.82v-58.4h12.78c11.12,0,18.25,3.48,18.25,20.08v18.25c0,16.62-7.13,20.08-18.25,20.08h-12.78Z",
    fill: "#ff5758"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.46edfaa128b6c60afc073571cb8dbfb2.svg";
export { ForwardRef as ReactComponent };